import { render } from "./ListeCategorieInfoPage.vue?vue&type=template&id=6ca53473&ts=true"
import script from "./ListeCategorieInfoPage.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieInfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__